import { notifyError, notifySuccess } from "../components/Toast";
const API_URL = process.env.REACT_APP_API_BASE_URL;

const newStrategyKey = (planId) => `new:strategy:${planId}`;
const newGoalKey = (strategyId) => `new:goal:${strategyId}`;
const newResourceKey = (strategyId) => `new:resource:${strategyId}`;
const newResponsibleKey = (strategyId) => `new:responsible:${strategyId}`;

export const saveObjective = (evaluationId, objective, user, opts = { refetch: true }) => {
  return async (dispatch) => {
    const key = objective?.Id ?? `new:objective:${evaluationId}`;
    dispatch({ type: "SAVE_OBJECTIVE_REQUEST", payload: { id: key } });

    try {
      const res = await fetch(`${API_URL}reportes/evaluaciones/${evaluationId}/plan-mejora`, {
        method: "POST",
        headers: { "Content-Type": "application/json", "Authorization": `Bearer ${user.token}` },
        body: JSON.stringify(objective)
      });

      if (res.ok) {
        dispatch({ type: "SAVE_OBJECTIVE_SUCCESS", payload: { id: key } });
        notifySuccess("Objetivo guardado con éxito");
        if (opts.refetch) await dispatch(getAllObjectives(evaluationId, user));
      } else {
        const err = await res.json();
        notifyError(err.message || "Error al guardar el objetivo");
        dispatch({ type: "SAVE_OBJECTIVE_FAIL", payload: { id: key, error: err.message } });
      }
    } catch (e) {
      notifyError("Error de conexión");
      dispatch({ type: "SAVE_OBJECTIVE_FAIL", payload: { id: key, error: e.message } });
    }
  };
};

export const deleteObjective = (objectiveId, evaluationId, user) => {
  return async (dispatch) => {
    dispatch({ type: "DELETE_OBJECTIVE_REQUEST", payload: { id: objectiveId } });

    try {
      const response = await fetch(`${API_URL}reportes/plan_de_mejora/${objectiveId}`, {
        method: "DELETE",
        headers: { 
          "Content-Type": "application/json",
          "Authorization": `Bearer ${user.token}`
        }
      });

      if (response.ok) {
        dispatch({ type: "DELETE_OBJECTIVE_SUCCESS", payload: { id: objectiveId } });
        notifySuccess("Se eliminó el objetivo correctamente");
        await dispatch(getAllObjectives(evaluationId, user));
      } else {
        const errorData = await response.json();
        notifyError(errorData.message || "Error al eliminar el objetivo");
        dispatch({ type: "DELETE_OBJECTIVE_FAIL", payload: { id: objectiveId, error: errorData.message } });
      }
    } catch (error) {
      notifyError("Error de conexión");
      dispatch({ type: "DELETE_OBJECTIVE_FAIL", payload: { id: objectiveId, error: error.message } });
    }
  };
};

export const completeObjective = (evaluationId, objectiveId, user) => {
  return async (dispatch) => {
    dispatch({ type: "COMPLETE_OBJECTIVE_REQUEST", payload: { id: objectiveId } });

    try {
      const response = await fetch(`${API_URL}reportes/evaluaciones/plan-mejora/${objectiveId}/completar`, {
        method: "POST",
        headers: { 
          "Content-Type": "application/json",
          "Authorization": `Bearer ${user.token}`
        }
      });

      if (response.ok) {
        dispatch({ type: "COMPLETE_OBJECTIVE_SUCCESS", payload: { id: objectiveId } });
        notifySuccess("Se completó el objetivo correctamente");
        await dispatch(getAllObjectives(evaluationId, user));
      } else {
        const errorData = await response.json();
        notifyError(errorData.message || "Error al completar el objetivo");
        dispatch({ type: "COMPLETE_OBJECTIVE_FAIL", payload: { id: objectiveId, error: errorData.message } });
      }
    } catch (error) {
      notifyError("Error de conexión");
      dispatch({ type: "COMPLETE_OBJECTIVE_FAIL", payload: { id: objectiveId, error: error.message } });
    }
  };
};

export const getAllObjectives = (evaluationId, user) => {
  return async (dispatch) => {
    dispatch({ type: "GET_ALL_OBJECTIVE_REQUEST" });

    try {
      const response = await fetch(`${API_URL}reportes/evaluaciones/${evaluationId}/plan-mejora`, {
        method: "GET",
        headers: { 
          "Content-Type": "application/json",
          "Authorization": `Bearer ${user.token}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        dispatch({ type: "GET_ALL_OBJECTIVE_SUCCESS", payload: data });
        return data;
      } else {
        const errorData = await response.json();
        notifyError(errorData.message || "Error al obtener los objetivos");
        dispatch({ type: "GET_ALL_OBJECTIVE_FAIL", payload: errorData.message });
      }
    } catch (error) {
      notifyError("Error de conexión");
      dispatch({ type: "GET_ALL_OBJECTIVE_FAIL", payload: error.message });
    }
  };
};

export const saveStrategy = (strategy, planId, evaluationId, user, opts = { refetch: true }) => {
  return async (dispatch) => {
    const key = strategy?.Id ?? `new:strategy:${planId}`;
    dispatch({ type: "SAVE_ESTRATEGIA_REQUEST", payload: { id: key } });

    try {
      const res = await fetch(`${API_URL}reportes/plan-mejora/${planId}/estrategias`, {
        method: "POST",
        headers: { "Content-Type": "application/json", "Authorization": `Bearer ${user.token}` },
        body: JSON.stringify(strategy),
      });

      if (!res.ok) {
        const err = await res.json().catch(()=> ({}));
        throw new Error(err.message || "Error al guardar la estrategia");
      }

      dispatch({ type: "SAVE_ESTRATEGIA_SUCCESS", payload: { id: key } });
      if (opts.refetch) {
        await dispatch(getAllObjectives(evaluationId, user));
      }
    } catch (e) {
      dispatch({ type: "SAVE_ESTRATEGIA_FAIL", payload: { id: key, error: e.message } });
      notifyError(e.message);
    }
  };
};

export const deleteStrategy = (id, evaluationId, user) => {
  return async (dispatch) => {
    dispatch({ type: "DELETE_ESTRATEGIA_REQUEST", payload: { id } });

    try {
      const response = await fetch(`${API_URL}reportes/estrategias/${id}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${user.token}`
        },
      });

      if (response.ok) {
        dispatch({ type: "DELETE_ESTRATEGIA_SUCCESS", payload: { id } });
        notifySuccess("Estrategia eliminada correctamente");
        await dispatch(getAllObjectives(evaluationId, user));
      } else {
        const errorData = await response.json();
        dispatch({ type: "DELETE_ESTRATEGIA_FAIL", payload: { id, error: errorData.message } });
        notifyError(errorData.message || "Error al eliminar la estrategia");
      }
    } catch (error) {
      dispatch({ type: "DELETE_ESTRATEGIA_FAIL", payload: { id, error: error.message } });
      notifyError("Error de conexión");
    }
  };
};

export const saveGoal = (goal, strategyId, evaluationId, user) => {
  return async (dispatch) => {
    const key = goal?.Id ?? newGoalKey(strategyId);
    dispatch({ type: "SAVE_META_REQUEST", payload: { id: key } });

    try {
      const response = await fetch(`${API_URL}reportes/estrategias/${strategyId}/metas`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${user.token}`
        },
        body: JSON.stringify(goal)
      });

      if (response.ok) {
        dispatch({ type: "SAVE_META_SUCCESS", payload: { id: key } });
        await dispatch(getAllObjectives(evaluationId, user));
        notifySuccess("Meta guardada con éxito");
      } else {
        const errorData = await response.json();
        dispatch({ type: "SAVE_META_FAIL", payload: { id: key, error: errorData.message } });
        notifyError(errorData.message || "Error al guardar la meta");
      }
    } catch (error) {
      dispatch({ type: "SAVE_META_FAIL", payload: { id: key, error: error.message } });
      notifyError("Error de conexión");
    }
  };
};

export const deleteGoal = (id, strategyId, evaluationId, user) => {
  return async (dispatch) => {
    dispatch({ type: "DELETE_META_REQUEST", payload: { id } });

    try {
      const response = await fetch(`${API_URL}reportes/estrategias/metas/${id}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${user.token}`
        },
      });

      if (response.ok) {
        dispatch({ type: "DELETE_META_SUCCESS", payload: { id } });
        notifySuccess("Meta eliminada correctamente");
        await dispatch(getAllObjectives(evaluationId, user));
      } else {
        const errorData = await response.json();
        dispatch({ type: "DELETE_META_FAIL", payload: { id, error: errorData.message } });
        notifyError(errorData.message || "Error al eliminar la meta");
      }
    } catch (error) {
      dispatch({ type: "DELETE_META_FAIL", payload: { id, error: error.message } });
      notifyError("Error de conexión");
    }
  };
};

export const saveResource = (resource, strategyId, evaluationId, user) => {
  return async (dispatch) => {
    const key = resource?.Id ?? newResourceKey(strategyId);
    dispatch({ type: "SAVE_RECURSO_REQUEST", payload: { id: key } });

    try {
      const response = await fetch(`${API_URL}reportes/estrategias/${strategyId}/recursos`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${user.token}`
        },
        body: JSON.stringify(resource),
      });

      if (response.ok) {
        dispatch({ type: "SAVE_RECURSO_SUCCESS", payload: { id: key } });
        await dispatch(getAllObjectives(evaluationId, user));
        notifySuccess("Recurso guardado con éxito");
      } else {
        const errorData = await response.json();
        dispatch({ type: "SAVE_RECURSO_FAIL", payload: { id: key, error: errorData.message } });
        notifyError(errorData.message || "Error al guardar el recurso");
      }
    } catch (error) {
      dispatch({ type: "SAVE_RECURSO_FAIL", payload: { id: key, error: error.message } });
      notifyError("Error de conexión");
    }
  };
};

export const deleteResource = (id, evaluationId, user) => {
  return async (dispatch) => {
    dispatch({ type: "DELETE_RECURSO_REQUEST", payload: { id } });

    try {
      const response = await fetch(`${API_URL}reportes/estrategias/recursos/${id}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${user.token}`
        },
      });

      if (response.ok) {
        dispatch({ type: "DELETE_RECURSO_SUCCESS", payload: { id } });
        notifySuccess("Recurso eliminado correctamente");
        await dispatch(getAllObjectives(evaluationId, user));
      } else {
        const errorData = await response.json();
        dispatch({ type: "DELETE_RECURSO_FAIL", payload: { id, error: errorData.message } });
        notifyError(errorData.message || "Error al eliminar el recurso");
      }
    } catch (error) {
      dispatch({ type: "DELETE_RECURSO_FAIL", payload: { id, error: error.message } });
      notifyError("Error de conexión");
    }
  };
};

export const saveResponsible = (responsible, strategyId, evaluationId, user) => {
  return async (dispatch) => {
    const key = responsible?.Id ?? newResponsibleKey(strategyId);
    dispatch({ type: "SAVE_RESPONSABLE_REQUEST", payload: { id: key } });

    try {
      const response = await fetch(`${API_URL}reportes/estrategias/${strategyId}/responsables`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${user.token}`
        },
        body: JSON.stringify(responsible),
      });

      if (response.ok) {
        dispatch({ type: "SAVE_RESPONSABLE_SUCCESS", payload: { id: key } });
        await dispatch(getAllObjectives(evaluationId, user));
        //notifySuccess("Responsable guardado correctamente");
      } else {
        const errorData = await response.json();
        dispatch({ type: "SAVE_RESPONSABLE_FAIL", payload: { id: key, error: errorData.message } });
        notifyError(errorData.message || "Error al guardar el responsable");
      }
    } catch (error) {
      dispatch({ type: "SAVE_RESPONSABLE_FAIL", payload: { id: key, error: error.message } });
      notifyError("Error de conexión");
    }
  };
};

export const deleteResponsible = (id, evaluationId, user) => {
  return async (dispatch) => {
    dispatch({ type: "DELETE_RESPONSABLE_REQUEST", payload: { id } });

    try {
      const response = await fetch(`${API_URL}reportes/estrategias/responsables/${id}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${user.token}`,
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Error al eliminar el responsable");
      }

      dispatch({ type: "DELETE_RESPONSABLE_SUCCESS", payload: { id } });
      await dispatch(getAllObjectives(evaluationId, user));
    } catch (error) {
      dispatch({ type: "DELETE_RESPONSABLE_FAIL", payload: { id, error: error.message } });
      notifyError("Error de conexión");
    }
  };
};
